export function ScrollToBottomButton({ onClick }) {
  return (
    <button className="scroll-to-bottom-btn" onClick={onClick}>
      <svg
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round"
          d="M19 14l-7 7m0 0l-7-7m7 7V3"
        />
      </svg>
    </button>
  );
}



// // components/common/ScrollToBottomButton.jsx
// import React from 'react';

// export const ScrollToBottomButton = ({ onClick }) => (
//   <button
//     onClick={onClick}
//     style={{
//       position: 'absolute',
//       bottom: 100,
//       right: 20,
//       zIndex: 200,
//       width: 36,
//       height: 36,
//       borderRadius: '50%',
//       background: '#5B21B6',
//       color: 'white',
//       border: 'none',
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       boxShadow: '0 4px 12px rgba(91,33,182,0.35)',
//     }}
//   >
//     <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
//       <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
//     </svg>
//   </button>
// );